import React from 'react';
import FormSection from '../../FormElements/FormSection';
import Label from '../../FormElements/Label';
import TextInput from '../../FormElements/TextInput';
import FormSubmit from '../../FormElements/FormSubmit';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import LoaderOverlay from '../../LoaderOverlay/LoaderOverlay';

export default class EditGroupForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			hasError: false,
			globalErrors: [],
			fieldErrors: null,
			name: '',
			description: ''
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		if (this.props.iam_get_group_endpoint && this.props.isEditing === true) {
			this.loadData();
		}
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.iam_get_group_endpoint !== this.props.iam_get_group_endpoint &&
			isEditing === true
		) {
			this.loadData();
		}
	}

	render() {
		return (
			<div className="FormElements">
				<form onSubmit={this.onSubmit}>
					<FormSection>
						<GlobalErrorsBox globalErrors={this.state.globalErrors} />
						<div className="my-3">
							<Label>{I18n.t('admin.group_name')}</Label>
							<TextInput
								style={this.styleTextInputOnError('name')}
								placeholder=""
								name="name"
								value={this.state.name}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
						<div className="my-3">
							<Label>{I18n.t('admin.group_description')}</Label>
							<TextInput
								style={this.styleTextInputOnError('description')}
								placeholder=""
								name="description"
								value={this.state.description}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
					</FormSection>
					<FormSubmit
						text={
							this.props.isEditing ? (
								I18n.t('admin.update_group_submit_button')
							) : (
								I18n.t('admin.create_group_submit_button')
							)
						}
					/>
				</form>
				{this.state.loading ? <LoaderOverlay /> : null}
			</div>
		);
	}

	styleTextInputOnError(fieldName) {
		if (this.state.fieldErrors) {
			if (fieldName in this.state.fieldErrors) {
				return { border: '1px solid #ff3d60', borderRadius: '5px' };
			}
		}
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			loading: true,
			globalErrors: null,
			fieldErrors: null
		});

		$.ajax({
			type: 'POST',
			url: this.props.isEditing ? this.props.iam_update_group_endpoint : this.props.iam_create_group_endpoint,
			data: {
				id: this.props.group_id,
				name: this.state.name,
				description: this.state.description
			},
			dataType: 'json'
		}).done((data) => {
			// console.log('Done!', data);
			if (data.status == 'success') {
				// console.log('Account successfully created!', data);
				this.setState({
					loading: false
				});
				this.props.onHidePopup();
				this.props.onShowSuccessCardPopup();
				this.props.onActionCompleted();	
			} else if (data.status == 'session_expired') {
				// console.log('Session expired!');
				this.props.onHidePopup();
				this.props.onShowTimeoutCardPopup(
					setTimeout(() => {
						window.location.href = `/admin/${this.props.public_id}/signin`;
					}, 5000)
				);
			} else {
				// console.log('Group creation failed!');
				this.setState({
					loading: false,
					globalErrors: data.global_errors,
					fieldErrors: data.field_errors
				});
			}
		});
	}

	loadData() {
		this.setState({ loading: true });
		$.ajax({
			type: 'GET',
			url: this.props.iam_get_group_endpoint,
			data: {
				id: this.props.group_id
			}
		}).done((payload) => {
			const result = payload;
			console.log('loadData done', result);
			this.setState({
				loading: false,
				name: result.data.name,
				description: result.data.description
			});
		});
	}
}
